import styled from 'styled-components';

export const TableContainer = styled.div`
  background: #ffffff;
  border-radius: 22px;
  margin-top: 26px;
  width: 100%;
  max-height: calc(100vh - 260px);
  overflow: auto;
  position: relative;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
export const ScrollBlock = styled.div`
  position: relative;
`;

export const FloatingScrollWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: ${(props) => props.$containerWidth}px;
  left: ${(props) => props.$containerLeft}px;
  overflow-x: auto;
  z-index: 9999;
  background: transparent;
  display: ${(props) => (props.$isVisible ? 'block' : 'none')};

  &::-webkit-scrollbar {
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c757d;
    border-radius: 12px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const FakeContent = styled.div`
  height: 1px;
  pointer-events: none;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
`;

export const TableRow = styled.tr``;

export const TableHeader = styled.th`
  padding: 20px 24px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #212529;
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: 1px solid #e2e8f0;

  position: sticky;
  top: 0;
  z-index: 50;
  background: #f8fafc;
  min-width: 170px;

  &:first-child {
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
  }

  &:nth-child(1) {
    left: 0;
    min-width: 180px;
    width: 180px;
    z-index: 70;
  }

  &:nth-child(2) {
    left: 180px;
    min-width: 170px;
    width: 170px;
    z-index: 70;
  }

  &:nth-child(3) {
    left: 350px;
    min-width: 170px;
    width: 170px;
    z-index: 70;
  }

  &.sticky-employee {
    left: 520px;
    min-width: 170px;
    width: 170px;
    z-index: 70;
  }
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td`
  padding: 16px 20px;
  font-size: 14px;
  color: #212529;
  vertical-align: middle;
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s;
  position: relative;
  min-width: 170px;
  padding-bottom: ${(props) => (props.$hasActions ? '36px' : '16px')};
  &:nth-child(1) {
    position: sticky;
    left: 0;
    min-width: 180px;
    width: 180px;
    z-index: 30;
    background: #ffffff;
  }

  &:nth-child(2) {
    position: sticky;
    left: 180px;
    min-width: 170px;
    width: 170px;
    z-index: 30;
    background: #ffffff;
  }

  &:nth-child(3) {
    position: sticky;
    left: 350px;
    min-width: 170px;
    width: 170px;
    z-index: 30;
    background: #ffffff;
  }
  &.sticky-employee {
    position: sticky;
    left: 520px;
    min-width: 170px;
    width: 170px;
    z-index: 30;
    background: #ffffff;
  }
`;

export const ActionName = styled.div`
  font-weight: 400;
  color: #212529;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TypeBadge = styled.span`
  padding: 4px 20px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  background: ${(props) => (props.$isPrimary ? '#2d6cdf1a' : '#2d6cdf1a')};
  color: ${(props) => (props.$isPrimary ? '#2D6CDF' : '#2D6CDF')};
  text-transform: capitalize;
`;

export const EmployeeName = styled.div`
  font-size: 14px;
  color: #212529;
`;

export const WeekCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(props) =>
    props.$isDisabled &&
    `
    opacity: 0.4;
    background-color: #f0f0f0;
    pointer-events: none;
    filter: grayscale(1);
  `}
`;

export const DualColumnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
`;

export const ColumnSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ColumnHeader = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: #374151;
  margin-bottom: 4px;
  text-align: center;
  padding: 4px;
  background-color: #f3f4f6;
  border-radius: 4px;
`;

export const WeekRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ $type }) => {
    switch ($type) {
      case 'plan':
        return '#f9fafb';
      case 'pres':
        return '#EFF6FF';
      case 'act':
        return '#15C7A71A';
      default:
        return 'transparent';
    }
  }};
  border-radius: 4px;
  padding: 4px 8px;
  min-width: 150px;
  ${({ $isEditable }) =>
    $isEditable &&
    `
    background-color: #f0f7ff; 
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    transform: scale(1.02); 
    border: 1px solid #dbeafe;
    z-index: 2;
  `}
  ${({ $isEditable, $type }) =>
    $isEditable &&
    `
    background-color: ${$type === 'act' ? '#f0fdf4' : '#f0f7ff'};
    border: 1px solid ${$type === 'act' ? '#dcfce7' : '#dbeafe'};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    transform: scale(1.02);
    z-index: 2;
  `}
`;

export const WeekLabel = styled.span`
  font-weight: 500;
  color: #6a7282;
  min-width: 35px;
`;

export const WeekValue = styled.div`
  width: 100%;
  padding: 4px 8px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  text-align: right;
  background: transparent;
  color: ${({ $type, disabled }) =>
    disabled
      ? '#94a3b8'
      : $type === 'plan'
        ? '#101828'
        : $type === 'pres'
          ? '#2D6CDF'
          : $type === 'act'
            ? '#15C7A7'
            : '#1e293b'};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }
`;

export const StatusBadge = styled.span`
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }
  text-align: center;
  background: ${(props) => {
    switch (props.$status) {
      case 'APPROVED':
        return '#15C7A71A';
      case 'MODIFIED':
        return '#9810FA1A';
      case 'PENDING':
        return '#FAA11C1A';
      default:
        return '#F3F4F6';
    }
  }};
  color: ${(props) => {
    switch (props.$status) {
      case 'APPROVED':
        return '#15C7A7';
      case 'MODIFIED':
        return '#9810FA';
      case 'PENDING':
        return '#FAA11C';
      default:
        return '#6B7280';
    }
  }};
`;

export const MonthlyAnalysis = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 100px;
`;

export const AnalysisValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2d6cdf;
  text-align: center;
`;

export const AnalysisLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #6a7282;
  text-align: center;
`;

export const KPIStatus = styled.div`
  font-weight: 500;
  font-size: 11px;

  color: ${(props) => {
    switch (props.$status) {
      case 'GOOD':
        return '#059669';
      case 'WARNING':
        return '#D97706';
      case 'BAD':
        return '#DC2626';
      default:
        return '#6A7282';
    }
  }};
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  position: absolute;
  bottom: 6px;
  right: 0;
  padding-right: 20px;
`;

export const IconButton = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &.submit-pres {
    background-color: #2d6cdf;
    width: 100%;
    border-radius: 4px;
    padding: 6px 8px;
    height: auto !important;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    color: #fff;
  }
`;
export const SelectDep = styled.div`
  padding: 40px;
  text-align: center;
  color: #212529;
`;

export const CommentFormGroup = styled.div`
  margin-bottom: 16px;
`;

export const CommentLabel = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
`;

export const CommentInput = styled.input`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  padding: 0 12px;

  border: 1px solid ${({ $error }) => ($error ? '#ef4444' : '#d9d9d9')};

  &:focus {
    border-color: ${({ $error }) => ($error ? '#ef4444' : '#2d6cdf')};
  }
`;

export const CommentTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 12px;
  resize: none;
`;

export const HistoryContent = styled.div`
  max-height: 520px;
  overflow: visible;
  padding: 4px 6px 8px 14px;
  max-height: none;
`;

export const HistoryTimeline = styled.div`
  position: relative;
  padding-left: 28px;
`;

export const HistoryLine = styled.div`
  position: absolute;
  left: 14px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #dfe8f5;
`;

export const HistoryItem = styled.div`
  position: relative;
  min-height: 74px;
  padding: 0 0 16px 20px;
  font-size: 12px;
  color: #64748b;
`;

export const HistoryIconCircle = styled.div`
  position: absolute;
  left: -28px;
  top: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HistoryIconText = styled.span`
  color: #ffffff;
  font-size: 15px;
`;

export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
`;

export const HistoryTitle = styled.span`
  color: #6c757d;
  font-weight: 500;
`;

export const HistoryField = styled.div`
  margin-bottom: 3px;
`;

export const HistoryFieldName = styled.span`
  color: #90a1b9;
  margin-right: 8px;
`;

export const HistoryValue = styled.span`
  color: #2d6cdf;
  font-weight: 500;
`;

export const HistoryDate = styled.div`
  color: #90a1b9;
  margin-top: 3px;
`;

export const HistoryComment = styled.div`
  margin-top: 8px;
  width: 280px;
  min-height: 34px;
  border: 1px solid #e5eaf3;
  border-radius: 8px;
  padding: 8px 12px;
  color: #334155;
  background: #ffffff;
`;

export const HistoryEmpty = styled.div`
  padding: 16px;
`;

export const HistoryLoading = styled.div`
  padding: 24px;
`;

export const HistoryModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  padding-left: 15px;
`;

export const HistoryModalHeaderIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const HistoryModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #212529;
`;

export const StatusTooltipBox = styled.div`
  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  position: absolute;
  top: 50%;
  left: calc(100% + 14px);
  transform: translateY(-50%);

  width: 260px;
  background: #ffffff;
  border-radius: 14px;
  padding: 12px 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  z-index: 999999;

  display: flex;
  gap: 10px;
`;

export const StatusTooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: visible;

  &:hover ${StatusTooltipBox} {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;
export const StatusTooltipAvatar = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: 50%;
  background: #b84acb;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover + ${StatusTooltipBox} {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

export const StatusTooltipContent = styled.div`
  font-size: 12px;
  color: #6c757d;
  line-height: 18px;
`;

export const StatusTooltipName = styled.span`
  font-weight: 700;
  color: #212529;
`;

export const StatusTooltipTime = styled.span`
  color: #90a1b9;
`;

export const StatusTooltipTrigger = styled.div`
  width: 22px;
  height: 22px;
  min-width: 22px;

  border-radius: 50%;
  background: #b84acb;
  color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  position: absolute;
  top: -8px;
  right: -10px;
  z-index: 10;
`;
